<template>
    <div class="flex flex-column flex-grow-1" :class="background">
        <main class="flex-grow-1">
            <slot name="header"></slot>
            <div :class="{ container }">
                <slot></slot>
            </div>
        </main>
        <Footer v-if="footer" />
    </div>
</template>



<script>
import Footer from '@/components/footer/Footer.vue';

export default {
    components: {
        Footer
    },
    props: {
        background: {
            type: String,
            default: ''
        },
        footer: {
            type: Boolean,
            default: true
        },
        container: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style scoped>
main {
    padding-top: 80px;
}

.lightGrey {
    background-image: url('../../assets/img/tooliaba_seemless_texture_1.jpg');
    background-repeat: repeat;
}

.darkGrey {
    background-image: url('../../assets/img/texture_blackstone.jpg');
    background-size: cover;
    background-attachment: fixed;
}

.darkGreyPartial {
    background-image: url('../../assets/img/texture_blackstone.jpg');
    background-repeat: repeat-x;
}
</style>
